<script setup lang="ts">
import { DtwinCertificateImg } from "~/modules/dtwin/models/DtwinCertificateImg.enum";
import ILxCertificateExpired from "~icons/lxc-business/certificate-expired";
import ILxCertificateValidityGreaterThanSixMonths from "~icons/lxc-business/certificate-validity-greater-than-six-months";
import ILxCertificateValidityLessThanOneMonths from "~icons/lxc-business/certificate-validity-less-than-one-months";
import ILxCertificateValidityLessThanSixMonths from "~icons/lxc-business/certificate-validity-less-than-six-months";
import ILxCertificateValidityLessThanThreeMonths from "~icons/lxc-business/certificate-validity-less-than-three-months";

defineProps<{
  icon: DtwinCertificateImg;
}>();
</script>
<template>
  <i-lx-certificate-validity-greater-than-six-months
    v-if="icon === DtwinCertificateImg.VALIDITY_GREATER_THAN_SIX_MONTHS"
  />
  <i-lx-certificate-validity-less-than-six-months
    v-if="icon === DtwinCertificateImg.VALIDITY_LESS_THAN_SIX_MONTHS"
  />
  <i-lx-certificate-validity-less-than-three-months
    v-if="icon === DtwinCertificateImg.VALIDITY_LESS_THAN_THREE_MONTHS"
  />
  <i-lx-certificate-validity-less-than-one-months
    v-if="icon === DtwinCertificateImg.VALIDITY_LESS_THAN_ONE_MONTH"
  />
  <i-lx-certificate-expired v-if="icon === DtwinCertificateImg.EXPIRED" />
</template>
